import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import CarModels from './carModels';
import ReplacementInfo from '../info/replacementInfo';

class Compatibility extends Component {
  componentDidMount() {
    this.props.getPartCarModels();
  }

  render() {
    return (
      <Card raised fluid className='compatibility'>
        <ReplacementInfo />
        <CarModels />
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'partCode': state.partsMaster.values.partCode,
    'franchise': state.partsMaster.values.franchise,
    'loadingPartCarModels': state.partsMaster.loadingPartCarModels,
    'loadingCompatibility': state.partsMaster.loadingCompatibility,
    'partCarModels': state.partsMaster.partCarModels,
    'compatibility': state.partsMaster.compatibility,
  };
};

const {getPartCarModels, savePartCarCompatibility} = Actions;

export default connect(mapStateToProps, {getPartCarModels, savePartCarCompatibility})(Compatibility);
